import { IController } from 'angular';
import * as _ from 'lodash';
import { RegentsSubject } from '../../../../../../ng2/shared/constants/regents.constant';
import { ActiveSupportCategories } from '../../../../../../ng2/shared/constants/support-categories.constant';
import { ImSupport } from './../../../../../shared/static-models/im-models/im-support.service';
import { supportSubjectOptionsBySchool } from './support-subject-options-by-school.constant';

/***********************************************************
 *  TODO: Rename this file. Should not be called "name-step"
 *  Does much more than this (JC)
 **********************************************************/

export class NameStepCtrl implements IController {
  static $inject = ['$scope', 'ImSupport'];

  // Bindings
  private supportId;
  private currentSchool;
  private currentSupportName;
  private currentSupport;
  private exams;
  private subjectOptions;
  private categories;

  validSchoolForAcademicCat;

  constructor(private $scope, private imSupport: ImSupport) {}

  $onInit() {
    this.currentSupportName = angular.copy(this.currentSupport.name); // copy the initial support.name on load

    if (this.supportId === 'duplicate') this.currentSupport.name = `Copy of ${this.currentSupport.name}`;

    this.exams = RegentsSubject;

    this.subjectOptions = supportSubjectOptionsBySchool[this.currentSchool.schoolType];

    this.categories = ActiveSupportCategories;
  }

  // Functions
  supportNameValidator = (currentSupports, UserEnteredSupportName, currentSupportId, currentSupportName) => {
    let userEnteredSupportName = UserEnteredSupportName || '';
    let supportIDs = [];
    let allSupportNames = [];

    _.forEach(currentSupports, (support: any) => {
      if (!this.imSupport.isDeleted(support)) allSupportNames.push(support.name.toLowerCase());
      supportIDs.push(support._id);
    });

    let newSupport = !_.includes(supportIDs, currentSupportId);
    let allSupportNamesButCurrent = !newSupport ? _.pull(allSupportNames, currentSupportName.toLowerCase()) : '';

    if (newSupport) {
      // creating a new support
      return _.includes(allSupportNames, userEnteredSupportName.toLowerCase())
        ? 'Sorry, that name is already in use'
        : false;
    } else {
      // editing an existing support
      return _.includes(allSupportNamesButCurrent, userEnteredSupportName.toLowerCase())
        ? 'Sorry, that name is already in use'
        : false;
    }
  };

  validateNameStep = currentSupport => {
    return !currentSupport.name || !currentSupport.category ? true : false;
  };

  resetSupportMetaData(support) {
    support.setMetaData({ category: support.category });
  }
}

angular.module('nv.SupportsModule').controller('nameStepCtrl', NameStepCtrl);
